<template>
  <div class="animated fadeIn rtps-dashboard">
    <div>The RTPS Internal Dashboard is temporarily located in the following location:</div>
    <div>
      (copy and paste in windows explorer)<br/>
      \\pscfp0002.pdrit.com\PDR_Common\Copay_ePA_RTPS_internal_dashboard\RTPS_internal_dashboard
    </div>
    <div>
      For any issues please email:
      <a href="mailto:Andrew.Soliman@connectiverx.com">Andrew.Soliman@connectiverx.com</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "RTPSDashboard"
};
</script>

<style lang="scss" scoped>
.rtps-dashboard {
  padding: 50px;
  div {
    padding-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTPSDashboard.vue